export const marketIncludedColums=[
    {
        marketId:9,
        description:"Instrumento"  
    },
    {
        marketId:9,
        description:"Precio"
    },
    {
        marketId:9,
        description:"Variación"
    },
    {
        marketId:9,
        description:"Variación %"
    },
    {
        marketId:9,
        description:"Precio anterior"
    },
    {
        marketId:9,
        description:"Fecha precio anterior"
    },
    {
        marketId:9,
        description:"Precio de compra"
    },
    {
        marketId:9,
        description:"Precio de venta"
    },
    {
        marketId:9,
        description:"Spread"
    },
    {
        marketId:9,
        description:"Fecha"
    },
    {
        marketId:9,
        description:"Hora"
    },
    {
        marketId:9,
        description:"Máximo del día"
    },
    {
        marketId:9,
        description:"Mínimo del día"
    },
    {
        marketId:9,
        description:"Descripción"
    },

    {
        marketId:8,
        description:"Instrumento"
    },
    
    {
        marketId:8,
        description:"Variación"
    },
    
    {
        marketId:8,
        description:"Precio"
    },
    
    {
        marketId:8,
        description:"Variación %"
    },
    {
        marketId:8,
        description:"Precio anterior"
    },
    
    {
        marketId:8,
        description:"Fecha"
    },
    
    {
        marketId:8,
        description:"Volumen"
    },
    
    {
        marketId:8,
        description:"Hora"
    },
    {
        marketId:8,
        description:"Máximo del día"
    },
    
    {
        marketId:8,
        description:"Mínimo del día"
    },
    
    {
        marketId:8,
        description:"Precio de apertura"
    },
    
    {
        marketId:8,
        description:"Descripción"
    },


    {
        marketId:21,
        description:"Instrumento"
    },
    {
        marketId:21,
        description:"Descripción"
    },
    {
        marketId:21,
        description:"Nivel actual"
    },
    {
        marketId:21,
        description:"Nivel anterior"
    },
    {
        marketId:21,
        description:"Frecuencia"
    },
    {
        marketId:21,
        description:"Unidades"
    },
    {
        marketId:21,
        description:"Última actualización"
    },
    {
        marketId:21,
        description:"Tipo de serie"
    },

    {
        marketId:23,
        description:"Instrumento"
    },

    {
        marketId:23,
        description:"Precio"
    },

    {
        marketId:23,
        description:"Precio Anterior"
    },

    {
        marketId:23,
        description:"Variación"
    },

    {
        marketId:23,
        description:"Variación %"
    },

    {
        marketId:23,
        description:"Hora"
    },

    {
        marketId:23,
        description:"Rendimiento del año (Anualizado)"
    },

    {
        marketId:23,
        description:"Rendimiento mensual (Anualizado)"
    },

    {
        marketId:23,
        description:"Rendimiento semanal (Anualizado)"
    },

    {
        marketId:23,
        description:"Rendimiento del año"
    },

    {
        marketId:23,
        description:"Rendimiento semanal"
    },

    {
        marketId:23,
        description:"Rendimiento anual"
    },

    {
        marketId:23,
        description:"Rendimiento mensual"
    },

    {
        marketId:23,
        description:"Precio mínimo (Últ. 12 meses)"
    },

    {
        marketId:23,
        description:"Precio máximo (Últ. 12 meses)"
    },

    {
        marketId:23,
        description:"Descripción"
    },

    {
        marketId:23,
        description:"ISIN"
    },

    {
        marketId:23,
        description:"Fecha anterior"
    },

    {
        marketId:23,
        description:"Fecha"
    },

    {
        marketId:27,
        description:"Instrumento"
    },
    {
        marketId:27,
        description:"Precio"
    },
    {
        marketId:27,
        description:"Volumen"
    },
    {
        marketId:27,
        description:"Precio de cierre"
    },
    {
        marketId:27,
        description:"Precio de apertura"
    },
    {
        marketId:27,
        description:"Variación"
    },
    {
        marketId:27,
        description:"Variación %"
    },
    {
        marketId:27,
        description:"Volumen acumulado"
    },
    {
        marketId:27,
        description:"Importe total"
    },
    {
        marketId:27,
        description:"Precio de compra"
    },
    {
        marketId:27,
        description:"Volumen de compra"
    },
    {
        marketId:27,
        description:"Precio de venta"
    },
    {
        marketId:27,
        description:"Volumen de venta"
    },
    {
        marketId:27,
        description:"Fecha"
    },
    {
        marketId:27,
        description:"Hora"
    },
    {
        marketId:27,
        description:"Hora postura"
    },
    {
        marketId:27,
        description:"Fecha postura"
    },
    {
        marketId:27,
        description:"Máximo del día"
    },
    {
        marketId:27,
        description:"Mínimo del día"
    },
    {
        marketId:27,
        description:"Precio máx. (Ult. 12 Meses)"
    },
    {
        marketId:27,
        description:"Precio min. (Ult. 12 Meses)"
    },
    {
        marketId:27,
        description:"Precio Promedio Ponderado"
    },
    {
        marketId:27,
        description:"ISIN"
    },
    {
        marketId:27,
        description:"Vendedor"
    },
    {
        marketId:27,
        description:"Comprador"
    },
    {
        marketId:27,
        description:"Descripción"
    },

    {
        marketId:24,
        description:"Instrumento"
    },
    {
        marketId:24,
        description:"Nombre"
    },
    {
        marketId:24,
        description:"Nivel actual"
    },
    {
        marketId:24,
        description:"Nivel anterior"
    },
    {
        marketId:24,
        description:"Vencimiento"
    },
    {
        marketId:24,
        description:"Disponibilidad"
    },
    {
        marketId:24,
        description:"Fuente"
    },
    {
        marketId:24,
        description:"Unidades"
    },
]

export const excludeTables=[
    {
        marketId:16,
        name:"Deuda Gubernamental"
    },
    {
        marketId:17,
        name:"Deuda Privada"
    },
    {
        marketId:25,
        name:"Deuda Internacional"
    },
    {
        marketId:26,
        name:"Materias Primas"
    }
]

export const tableOrder=[
    {
        marketId:27,
        name:"Capitales",
        order:1
    },
    {
        marketId:8,
        name:"Indices",
        order:2
    },
    {
        marketId:9,
        name:"Divisas",
        order:3
    },
    {
        marketId:23,
        name:"Fondos de Inversión",
        order:4
    },
    {
        marketId:21,
        name:"Indicadores",
        order:5
    },
    {
        marketId:24,
        name:"Tasas de Referencia",
        order:6
    }
]

export const historyInstruments=[
    
        {
            marketId:27,
            name:"Capitales",
            order:1,
            instruments:[
                {
                    Name:"Fecha",
                    IsChecked:false
                },
                {
                    Name:"Cierre",
                    IsChecked:false
                },
                {
                    Name:"Apertura",
                    IsChecked:false
                 
                },
                {
                    Name:"Máximo",
                    IsChecked:false
                 
                },
                {
                    Name:"Mínimo",
                    IsChecked:false
                 
                },
                {
                    Name:"Volumen",
                    IsChecked:false
                 
                },
            ]
        },
        {
            marketId:8,
            name:"Indices",
            order:2,
            instruments:[
                {
                    Name:"Fecha",
                    IsChecked:false
                },
                {
                    Name:"Cierre",
                    IsChecked:false
                },
                {
                    Name:"Apertura",
                    IsChecked:false
                 
                },
                {
                    Name:"Máximo",
                    IsChecked:false
                 
                },
                {
                    Name:"Mínimo",
                    IsChecked:false
                 
                },
                {
                    Name:"Volumen",
                    IsChecked:false
                 
                },
            ]
        },
        {
            marketId:9,
            name:"Divisas",
            order:3,
            instruments:[
                {
                    Name:"Fecha",
                    IsChecked:false
                },
                {
                    Name:"Cierre",
                    IsChecked:false
                },
                {
                    Name:"Apertura",
                    IsChecked:false
                 
                },
                {
                    Name:"Máximo",
                    IsChecked:false
                 
                },
                {
                    Name:"Mínimo",
                    IsChecked:false
                 
                },
                {
                    Name:"Volumen",
                    IsChecked:false
                 
                },
            ]
        },
        {
            marketId:23,
            name:"Fondos de Inversión",
            order:4,
            instruments:[
                {
                    Name:"Fecha",
                    IsChecked:false
                },
                {
                    Name:"Precio",
                    IsChecked:false
                },
                {
                    Name:"Rendimiento en el año",
                    IsChecked:false
                 
                },
                {
                    Name:"Rendimiento mensual",
                    IsChecked:false
                 
                },
                {
                    Name:"Rendimiento semanal",
                    IsChecked:false
                 
                },
                {
                    Name:"Rendimiento anual",
                    IsChecked:false
                 
                },

                {
                    Name:"Rendimiento anualizado en el año",
                    IsChecked:false
                },
                {
                    Name:"Rendimiento anualizado mensual",
                    IsChecked:false
                },
                {
                    Name:"Rendimiento anualizado semanal",
                    IsChecked:false
                },
             
            ] 
        },
        {
            marketId:21,
            name:"Indicadores",
            order:5,
            instruments:[
                {
                    Name:"Fecha",
                    IsChecked:false
                },
                {
                    Name:"Valor",
                    IsChecked:false
                },
            ]
        },
        {
            marketId:24,
            name:"Tasas de Referencia",
            order:6,
            instruments:[
                {
                    Name:"Fecha",
                    IsChecked:false
                },
                {
                    Name:"Nivel",
                    IsChecked:false
                },
            ]
        },
        {
            marketId:26,
            name:"Materias Primas",
            order:7,
            instruments:[
                {
                    Name:"Fecha",
                    IsChecked:false
                },
                {
                    Name:"Nivel",
                    IsChecked:false
                },
            ]
        },

]




